module.exports = __webpack_public_path__ + "img/wb_logo_cn.7e20fdd4.webp";